import { Component, Input } from '@angular/core'

import { Vehicle } from '@shared/models/vehicle.model'

@Component({
  selector: 'lin-report-by-vehicle-section',
  templateUrl: './report-by-vehicle-section.component.html',
  styleUrls: ['./report-by-vehicle-section.component.scss'],
  standalone: false,
})
export class ReportByVehicleSectionComponent {
  @Input() vehicle: Vehicle

  get groupTitle(): string {
    if (typeof this.vehicle.groups === 'string') return this.vehicle.groups

    const toName = ({ name }) => <string>name
    return this.vehicle.groups && this.vehicle.groups.map(toName).join(', ')
  }

  get depotTitle(): string {
    return typeof this.vehicle.depot === 'string' ? this.vehicle.depot : this.vehicle.depot.name
  }
}
